<template>
	<c-modal @close="close" title="Bulk afroep">

		<c-form ref="form" @valid="submit" class="margin-t-40">

			<div v-if="!edit">
				<h6 class="margin-t-40 margin-b-16">Van wie is deze bulk order?</h6>

				<c-select
					:horizontal="true"
					:label="'Eindklant'"
					:options="endcustomers"
					v-model="client_id"
					name="client_id"
					ValueName="id"
					DisplayName="name"
					@change="getProducts()">
				</c-select>

                <c-select
                    :horizontal="true"
                    :label="'Project'"
                    :options="projects"
                    v-model="project_id"
                    name="project_id"
                    ValueName="id"
                    DisplayName="number"
                    @change="getProductsByProjectId()"
                    v-if="this.projects.length !== 0">
                </c-select>

				<CSubForm name="products">
					<CSubForm v-for="count in itemCount" :name="count - 1" :key="count">
						<c-item
							@delete-item="removeItem"
							ref="items"
							:items="products"
							:bulk="true">
						</c-item>
					</CSubForm>
				</CSubForm>

				<a @click="addItem" class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
					<svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/></svg>
					<span>Nog een artikel toevoegen</span>
				</a>
			</div>

			<div v-else>
				<c-item
					v-for="product in productList" :key="product"
					@delete-item="removeItem"
					ref="items"
					:items="products"
					:product="product"
					:edit="edit"
					:bulk="true">
				</c-item>
			</div>


			<h6 class="c-text-icon margin-t-24 margin-b-16">Contact gegevens</h6>
				
			<c-input
				:label="'E-mailadres'"
				:horizontal="true"
				type="text"
				name="email"
				v-model="email"
				/>

			<c-input
				:label="'Telefoonnummer'"
				:horizontal="true"
				type="text"
				name="phone"
				v-model="phone"
				/>

			<c-input
				:label="'Contactpersoon'"
				:horizontal="true"
				type="text"
				name="contactpersoon"
				v-model="contactpersoon" />

			<h6 class="margin-t-40">Levering</h6>

			<c-input
				:label="'Ordernummer'"
				:horizontal="true"
				type="text"
				name="order_number"
				v-model="order_number" />

			<c-input
				:label="'Referentie'"
				:horizontal="true"
				type="text"
				name="your_reference"
				v-model="your_reference" />

			<c-custom-zipcode-address
                :label="'Afleveradres'"
                :addresses="addresses"
                v-model="address"
                name="address"
				ref="zipcode"
            />

			<c-datepicker
				:label="'Leverdatum'"
				name="date"
				:horizontal="true"
				v-model="date"
				:type="'future'">
			</c-datepicker>

			<c-textarea
				:label="'Opmerking'"
				:horizontal="true"
				type="textarea"
				name="description"
				v-model="description"
			/>

			<div class="margin-t-32">
                <c-input
                    @change="uploadFile"
                    :label="'Bestand'"
                    :horizontal="true"
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    name="file"
                    ref="file"
                />
            </div>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-b-16 no-margin-b" type="submit" :disabled="submitting">{{edit ? "Bestelling wijzigen" : "Bestelling plaatsen"}}</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CItem from '@components/Item';
import CDatepicker from '@components/form/input/Datepicker';
import { ValidationError } from '@app/errors';
import CCustomZipcodeAddress from '@components/CustomZipcodeAddress.vue';

export default {
	mixins: [Form],
	components: {
		CModal, CItem, CDatepicker, CCustomZipcodeAddress
	},
	props: {
		edit: {
			required: false,
			default: false
		},
		delivery: {
			required: false,
		},
		productList: {
			required: false
		}
	},
	data() {
		return {
			client_id: '',
			project_id: '',
			your_reference: '',
			description: '',
			date: '',
			itemCount: 1,
			endcustomers: '',
			projects: '',
			products: '',
			submitting: false,
            contactpersoon: '',
			order_number: '',
			address: {},
			addresses: [],
			contacts: {},
			file: null,
			email: '',
			phone: ''
		}
	},

	methods: {
		uploadFile(event) {
        	 let files = Array.from(event.target.files);
			 this.file = files[0];
			 this.errors = {};
      	},
		addItem() {
			this.itemCount++;
		},
		removeItem(product_id) {
			if(this.edit){
				let index = this.productList.findIndex( (product) => product.id == product_id);
				this.productList.splice(index, 1);
			}
			else {
				this.itemCount--;
			}
		},
		submit() {

			this.submitting = true;
			let submit_data = {
				client_id: this.client_id,
                project_id: this.project_id,
				description: this.description,
				date: this.date,
				your_reference: this.your_reference,
				order_number: this.order_number,
				contact: this.contactpersoon,
				address: this.address,
				delivery_type_id: this.$constants.delivery.BULK_LEVERING,
				file: this.file,
				contact_email: this.email,
				contact_phone: this.phone
			}

			let data = '';

           let ItemsData = {
				products: []
			};

			this.$refs.items.forEach( (component, index) => {

				for(let i = 0; i < component.expected; i++)
				{
					ItemsData['products'].push({product_id: component.product_id, is_pickup: 0});
				}
			});

			data = Object.assign(submit_data, ItemsData);

			if(this.edit){
				data._method = 'PUT';

				this.$xhr.post('/api/deliveries/' + this.delivery.id, data).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$store.dispatch('toast/success', {title: 'Bulk levering wijzigen', text: 'De Bulk levering is gewijzigd'});
					this.submitting = false;

				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Bulk levering wijzigen', text: 'Er is helaas iets fout gegaan bij het wijzigen van de bulk levering'});
					this.submitting = false;
				});
			}
			else{
				data.carrier_id = 1;
				this.$xhr.post('/api/deliveries', data).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$store.dispatch('toast/success', {title: 'Bulk levering aanvragen', text: 'De bulk levering is aangevraagd'});
					this.clear();

				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Bulk levering aanvragen', text: 'Er is helaas iets fout gegaan bij het aanvragen van de bulk levering'});
					this.submitting = false;
				});
			}

		},
		clear(){
			this.itemCount = 1;
			this.$refs.form.reset();
			this.submitting = false;
			this.client_id = '';
			this.project_id = '';
			this.contactpersoon = '';
			this.address = {};
			this.$refs.items[0].clear();
		},
        clearPerClient() {
            this.itemCount = 1;
            this.submitting = false;
            this.project_id = '';
            this.contactpersoon = '';
            this.address = {};
          //  this.$refs.items[0].clear();
        },
        clearPerProject() {
            this.itemCount = 1;
            this.submitting = false;
          //  this.$refs.items[0].clear();
        },
		getProducts() {
            this.clearPerClient();

			this.$xhr.get('/api/clients/' + this.client_id).then( ( {result}) => {
				this.products = result.available_products;
				this.addresses = result.addresses;
				this.contacts = result.contacts;
                this.projects = result.projects;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Producten kunnen niet worden ingeladen'});
			});
		},
        getProductsByProjectId() {
            this.clearPerProject();

            this.$xhr.get('/api/getproductsbyprojectid/' + this.project_id).then( ( {result}) => {
                this.products = result;
            });
        },
		close() {
			this.$emit('close');
		},
	},
	mounted(){
		this.$xhr.get('/api/getallendcustomers').then( ( {result}) => {
				this.endcustomers = result;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klanten kunnen niet worden ingeladen'});
		});

		if(this.edit){
			this.client_id = this.delivery.client_id;
			this.project_id = this.delivery.project_id;
			this.getProducts();

			this.description = this.delivery.description;
			this.date = this.delivery.date;
			this.your_reference = this.delivery.your_reference;
			this.address = this.delivery.address;
			this.order_number = this.delivery.order_number;
			this.contactpersoon = this.delivery.contact;
			this.email = this.delivery.contact_email;
			this.phone = this.delivery.contact_phone;
		}
	},
}
</script>
